
import Close from './close/Close'
import Edited from './edited/Edited'
import Error from './error/Error'
import Translate from './translate/Translate'
import Arrow from './Arrow'
import Spinner from './Spinner'

export const CloseIcon = Close
export const EditedIcon = Edited
export const ErrorIcon = Error
export const TranslateIcon = Translate
export const ArrowIcon = Arrow
export const SpinnerIcon = Spinner
